import { IActivityTrack, ISection, ISectionsStudyStatus } from '@sdk/contracts';
import React from 'react';

import {
  ActivitiesTrackingWrapper,
  IconContainer,
  ActivitiesTrackingNumbers,
  CompletionIcon
} from './ActivitiesTracking.styles';

import half from '@/assets/half.svg';
import quarter from '@/assets/quarter.svg';
import threeQuarters from '@/assets/three-quarter.svg';

type Props = {
  section: ISection | ISectionsStudyStatus;
  tracking: IActivityTrack[];
};

export const ActivitiesTracking: React.FC<Props> = ({ section, tracking }) => {
  const totalActivities = section.activities.length;

  const getActivityInfo = (activityId: string): IActivityTrack | undefined => {
    return tracking.find(track => track.activity === activityId);
  };

  const completedActivities = section.activities.filter(activity => {
    const { _id } = activity;
    const { isCompleted } = getActivityInfo(_id) || {};
    return isCompleted;
  });

  const completionRatio = completedActivities.length / totalActivities;

  return (
    <ActivitiesTrackingWrapper completion={completionRatio}>
      {completedActivities.length > 0 && (
        <IconContainer>
          {completionRatio < 0.5 ? (
            <img src={quarter} alt="quarter" />
          ) : completionRatio < 0.75 ? (
            <img src={half} alt="half" />
          ) : completionRatio < 1 ? (
            <img src={threeQuarters} alt="threeQuarters" />
          ) : (
            <CompletionIcon i="CheckmarkOutline" />
          )}
        </IconContainer>
      )}
      <ActivitiesTrackingNumbers completion={completionRatio}>
        {completedActivities.length}/{totalActivities}
      </ActivitiesTrackingNumbers>
    </ActivitiesTrackingWrapper>
  );
};
